import React from 'react'
import './card.css'

function Card({ children, className }) {
    return <div className={`card-section ${className}`}>{children}</div>
}

export default Card
